var map = {
	"./icons/mise/activity_unread_unselected": 66220,
	"./icons/mise/activity_unread_unselected.svg": 66220,
	"./icons/mise/activity_unselected": 67843,
	"./icons/mise/activity_unselected.svg": 67843,
	"./icons/mise/add_attachment_medium": 84059,
	"./icons/mise/add_attachment_medium.svg": 84059,
	"./icons/mise/add_attachment_regular": 91860,
	"./icons/mise/add_attachment_regular.svg": 91860,
	"./icons/mise/add_attachment_small": 62925,
	"./icons/mise/add_attachment_small.svg": 62925,
	"./icons/mise/add_comment_medium": 19372,
	"./icons/mise/add_comment_medium.svg": 19372,
	"./icons/mise/add_comment_regular": 85538,
	"./icons/mise/add_comment_regular.svg": 85538,
	"./icons/mise/add_comment_small": 65272,
	"./icons/mise/add_comment_small.svg": 65272,
	"./icons/mise/add_cooksnap_medium": 75235,
	"./icons/mise/add_cooksnap_medium.svg": 75235,
	"./icons/mise/add_cooksnap_regular": 13336,
	"./icons/mise/add_cooksnap_regular.svg": 13336,
	"./icons/mise/add_cooksnap_small": 15565,
	"./icons/mise/add_cooksnap_small.svg": 15565,
	"./icons/mise/add_reaction_medium": 28444,
	"./icons/mise/add_reaction_medium.svg": 28444,
	"./icons/mise/add_reaction_regular": 2415,
	"./icons/mise/add_reaction_regular.svg": 2415,
	"./icons/mise/add_reaction_small": 82012,
	"./icons/mise/add_reaction_small.svg": 82012,
	"./icons/mise/add_recipe_medium": 11319,
	"./icons/mise/add_recipe_medium.svg": 11319,
	"./icons/mise/add_recipe_regular": 17894,
	"./icons/mise/add_recipe_regular.svg": 17894,
	"./icons/mise/add_recipe_small": 73105,
	"./icons/mise/add_recipe_small.svg": 73105,
	"./icons/mise/add_tip_medium": 31633,
	"./icons/mise/add_tip_medium.svg": 31633,
	"./icons/mise/add_tip_regular": 90042,
	"./icons/mise/add_tip_regular.svg": 90042,
	"./icons/mise/add_tip_small": 19117,
	"./icons/mise/add_tip_small.svg": 19117,
	"./icons/mise/add_user_medium": 1953,
	"./icons/mise/add_user_medium.svg": 1953,
	"./icons/mise/add_user_regular": 9797,
	"./icons/mise/add_user_regular.svg": 9797,
	"./icons/mise/add_user_small": 7172,
	"./icons/mise/add_user_small.svg": 7172,
	"./icons/mise/added_user_medium": 92324,
	"./icons/mise/added_user_medium.svg": 92324,
	"./icons/mise/added_user_regular": 0,
	"./icons/mise/added_user_regular.svg": 0,
	"./icons/mise/added_user_small": 93026,
	"./icons/mise/added_user_small.svg": 93026,
	"./icons/mise/answer_regular": 7251,
	"./icons/mise/answer_regular.svg": 7251,
	"./icons/mise/answer_small": 16471,
	"./icons/mise/answer_small.svg": 16471,
	"./icons/mise/apple": 57803,
	"./icons/mise/apple.svg": 57803,
	"./icons/mise/arrow_down": 87443,
	"./icons/mise/arrow_down.svg": 87443,
	"./icons/mise/arrow_left": 89616,
	"./icons/mise/arrow_left.svg": 89616,
	"./icons/mise/arrow_right": 66613,
	"./icons/mise/arrow_right.svg": 66613,
	"./icons/mise/arrow_trend_up": 90424,
	"./icons/mise/arrow_trend_up.svg": 90424,
	"./icons/mise/arrow_up": 32037,
	"./icons/mise/arrow_up.svg": 32037,
	"./icons/mise/atachment_medium": 1268,
	"./icons/mise/atachment_medium.svg": 1268,
	"./icons/mise/attachment_regular": 12622,
	"./icons/mise/attachment_regular.svg": 12622,
	"./icons/mise/attachment_small": 66756,
	"./icons/mise/attachment_small.svg": 66756,
	"./icons/mise/bin_medium": 24396,
	"./icons/mise/bin_medium.svg": 24396,
	"./icons/mise/bin_regular": 66509,
	"./icons/mise/bin_regular.svg": 66509,
	"./icons/mise/bookmark_selected_medium": 42563,
	"./icons/mise/bookmark_selected_medium.svg": 42563,
	"./icons/mise/bookmark_selected_regular": 68211,
	"./icons/mise/bookmark_selected_regular.svg": 68211,
	"./icons/mise/bookmark_selected_small": 77622,
	"./icons/mise/bookmark_selected_small.svg": 77622,
	"./icons/mise/bookmark_unselected_medium": 97753,
	"./icons/mise/bookmark_unselected_medium.svg": 97753,
	"./icons/mise/bookmark_unselected_regular": 93487,
	"./icons/mise/bookmark_unselected_regular.svg": 93487,
	"./icons/mise/bookmark_unselected_small": 62100,
	"./icons/mise/bookmark_unselected_small.svg": 62100,
	"./icons/mise/bookmarks": 72904,
	"./icons/mise/bookmarks.svg": 72904,
	"./icons/mise/camera_medium": 51183,
	"./icons/mise/camera_medium.svg": 51183,
	"./icons/mise/camera_regular": 7417,
	"./icons/mise/camera_regular.svg": 7417,
	"./icons/mise/camera_small": 2534,
	"./icons/mise/camera_small.svg": 2534,
	"./icons/mise/chart_unselected": 84069,
	"./icons/mise/chart_unselected.svg": 84069,
	"./icons/mise/check_circle": 37100,
	"./icons/mise/check_circle.svg": 37100,
	"./icons/mise/check_regular": 38913,
	"./icons/mise/check_regular.svg": 38913,
	"./icons/mise/check_small": 26127,
	"./icons/mise/check_small.svg": 26127,
	"./icons/mise/chevron_down": 26889,
	"./icons/mise/chevron_down.svg": 26889,
	"./icons/mise/chevron_left": 85298,
	"./icons/mise/chevron_left.svg": 85298,
	"./icons/mise/chevron_right": 92356,
	"./icons/mise/chevron_right.svg": 92356,
	"./icons/mise/chevron_up": 19425,
	"./icons/mise/chevron_up.svg": 19425,
	"./icons/mise/close_circle_medium": 73719,
	"./icons/mise/close_circle_medium.svg": 73719,
	"./icons/mise/close_circle_regular": 13505,
	"./icons/mise/close_circle_regular.svg": 13505,
	"./icons/mise/close_circle_small": 83390,
	"./icons/mise/close_circle_small.svg": 83390,
	"./icons/mise/close_regular": 24534,
	"./icons/mise/close_regular.svg": 24534,
	"./icons/mise/close_small": 25331,
	"./icons/mise/close_small.svg": 25331,
	"./icons/mise/comment_medium": 57474,
	"./icons/mise/comment_medium.svg": 57474,
	"./icons/mise/comment_regular": 93795,
	"./icons/mise/comment_regular.svg": 93795,
	"./icons/mise/comment_small": 4327,
	"./icons/mise/comment_small.svg": 4327,
	"./icons/mise/cookbook_logo": 21867,
	"./icons/mise/cookbook_logo.svg": 21867,
	"./icons/mise/cookbook_regular": 25179,
	"./icons/mise/cookbook_regular.svg": 25179,
	"./icons/mise/cooksnap_medium": 81312,
	"./icons/mise/cooksnap_medium.svg": 81312,
	"./icons/mise/cooksnap_regular": 70637,
	"./icons/mise/cooksnap_regular.svg": 70637,
	"./icons/mise/cooksnap_small": 33202,
	"./icons/mise/cooksnap_small.svg": 33202,
	"./icons/mise/copy": 79492,
	"./icons/mise/copy.svg": 79492,
	"./icons/mise/crown": 5748,
	"./icons/mise/crown.svg": 5748,
	"./icons/mise/dana": 57962,
	"./icons/mise/dana.svg": 57962,
	"./icons/mise/edit": 3109,
	"./icons/mise/edit.svg": 3109,
	"./icons/mise/email_medium": 50176,
	"./icons/mise/email_medium.svg": 50176,
	"./icons/mise/email_regular": 9149,
	"./icons/mise/email_regular.svg": 9149,
	"./icons/mise/email_small": 58084,
	"./icons/mise/email_small.svg": 58084,
	"./icons/mise/eye_medium": 80908,
	"./icons/mise/eye_medium.svg": 80908,
	"./icons/mise/eye_regular": 61712,
	"./icons/mise/eye_regular.svg": 61712,
	"./icons/mise/eye_small": 53387,
	"./icons/mise/eye_small.svg": 53387,
	"./icons/mise/facebook": 28141,
	"./icons/mise/facebook.svg": 28141,
	"./icons/mise/flag": 982,
	"./icons/mise/flag.svg": 982,
	"./icons/mise/globe": 73302,
	"./icons/mise/globe.svg": 73302,
	"./icons/mise/go_pay": 79603,
	"./icons/mise/go_pay.svg": 79603,
	"./icons/mise/google": 43037,
	"./icons/mise/google.svg": 43037,
	"./icons/mise/grab_pay": 77600,
	"./icons/mise/grab_pay.svg": 77600,
	"./icons/mise/home_unselected": 39181,
	"./icons/mise/home_unselected.svg": 39181,
	"./icons/mise/instagram_post": 82555,
	"./icons/mise/instagram_post.svg": 82555,
	"./icons/mise/like_selected_medium": 71162,
	"./icons/mise/like_selected_medium.svg": 71162,
	"./icons/mise/like_selected_regular": 86435,
	"./icons/mise/like_selected_regular.svg": 86435,
	"./icons/mise/like_selected_small": 30559,
	"./icons/mise/like_selected_small.svg": 30559,
	"./icons/mise/like_unselected_medium": 28045,
	"./icons/mise/like_unselected_medium.svg": 28045,
	"./icons/mise/like_unselected_regular": 84370,
	"./icons/mise/like_unselected_regular.svg": 84370,
	"./icons/mise/like_unselected_small": 70773,
	"./icons/mise/like_unselected_small.svg": 70773,
	"./icons/mise/link": 20420,
	"./icons/mise/link.svg": 20420,
	"./icons/mise/locked_regular": 41323,
	"./icons/mise/locked_regular.svg": 41323,
	"./icons/mise/locked_small": 87203,
	"./icons/mise/locked_small.svg": 87203,
	"./icons/mise/menu": 97441,
	"./icons/mise/menu.svg": 97441,
	"./icons/mise/move_bars_medium": 70117,
	"./icons/mise/move_bars_medium.svg": 70117,
	"./icons/mise/move_bars_regular": 95578,
	"./icons/mise/move_bars_regular.svg": 95578,
	"./icons/mise/mymailru": 30149,
	"./icons/mise/mymailru.svg": 30149,
	"./icons/mise/odnoklassniki": 47274,
	"./icons/mise/odnoklassniki.svg": 47274,
	"./icons/mise/overflow_horizontal_medium": 25890,
	"./icons/mise/overflow_horizontal_medium.svg": 25890,
	"./icons/mise/overflow_horizontal_regular": 87748,
	"./icons/mise/overflow_horizontal_regular.svg": 87748,
	"./icons/mise/ovo": 357,
	"./icons/mise/ovo.svg": 357,
	"./icons/mise/phone": 56245,
	"./icons/mise/phone.svg": 56245,
	"./icons/mise/pin_regular": 57492,
	"./icons/mise/pin_regular.svg": 57492,
	"./icons/mise/pin_small": 39667,
	"./icons/mise/pin_small.svg": 39667,
	"./icons/mise/pinterest": 49844,
	"./icons/mise/pinterest.svg": 49844,
	"./icons/mise/play": 56609,
	"./icons/mise/play.svg": 56609,
	"./icons/mise/plus_circle": 11151,
	"./icons/mise/plus_circle.svg": 11151,
	"./icons/mise/plus_create_unselected": 37003,
	"./icons/mise/plus_create_unselected.svg": 37003,
	"./icons/mise/plus_medium": 28227,
	"./icons/mise/plus_medium.svg": 28227,
	"./icons/mise/plus_regular": 53478,
	"./icons/mise/plus_regular.svg": 53478,
	"./icons/mise/plus_small": 97942,
	"./icons/mise/plus_small.svg": 97942,
	"./icons/mise/premium_medium": 22042,
	"./icons/mise/premium_medium.svg": 22042,
	"./icons/mise/premium_rank_1": 39581,
	"./icons/mise/premium_rank_1.svg": 39581,
	"./icons/mise/premium_rank_2": 66261,
	"./icons/mise/premium_rank_2.svg": 66261,
	"./icons/mise/premium_rank_3": 99057,
	"./icons/mise/premium_rank_3.svg": 99057,
	"./icons/mise/premium_regular": 68051,
	"./icons/mise/premium_regular.svg": 68051,
	"./icons/mise/premium_unread_regular": 29190,
	"./icons/mise/premium_unread_regular.svg": 29190,
	"./icons/mise/print": 27424,
	"./icons/mise/print.svg": 27424,
	"./icons/mise/question": 28661,
	"./icons/mise/question.svg": 28661,
	"./icons/mise/recipe_medium": 78374,
	"./icons/mise/recipe_medium.svg": 78374,
	"./icons/mise/recipe_regular": 77796,
	"./icons/mise/recipe_regular.svg": 77796,
	"./icons/mise/recipe_small": 52061,
	"./icons/mise/recipe_small.svg": 52061,
	"./icons/mise/replies": 64831,
	"./icons/mise/replies.svg": 64831,
	"./icons/mise/search_unselected_medium": 6893,
	"./icons/mise/search_unselected_medium.svg": 6893,
	"./icons/mise/search_unselected_regular": 6910,
	"./icons/mise/search_unselected_regular.svg": 6910,
	"./icons/mise/search_unselected_small": 32704,
	"./icons/mise/search_unselected_small.svg": 32704,
	"./icons/mise/send": 73451,
	"./icons/mise/send.svg": 73451,
	"./icons/mise/settings_unselected": 32515,
	"./icons/mise/settings_unselected.svg": 32515,
	"./icons/mise/share": 27627,
	"./icons/mise/share.svg": 27627,
	"./icons/mise/shopee_pay": 13917,
	"./icons/mise/shopee_pay.svg": 13917,
	"./icons/mise/smartphone": 18231,
	"./icons/mise/smartphone.svg": 18231,
	"./icons/mise/switch": 95746,
	"./icons/mise/switch.svg": 95746,
	"./icons/mise/telegram": 64358,
	"./icons/mise/telegram.svg": 64358,
	"./icons/mise/tiktok": 87718,
	"./icons/mise/tiktok.svg": 87718,
	"./icons/mise/time_medium": 23315,
	"./icons/mise/time_medium.svg": 23315,
	"./icons/mise/time_regular": 77608,
	"./icons/mise/time_regular.svg": 77608,
	"./icons/mise/time_small": 81034,
	"./icons/mise/time_small.svg": 81034,
	"./icons/mise/tip": 77314,
	"./icons/mise/tip.svg": 77314,
	"./icons/mise/translate": 92029,
	"./icons/mise/translate.svg": 92029,
	"./icons/mise/twitter": 28288,
	"./icons/mise/twitter.svg": 28288,
	"./icons/mise/user_medium": 27957,
	"./icons/mise/user_medium.svg": 27957,
	"./icons/mise/user_regular": 59688,
	"./icons/mise/user_regular.svg": 59688,
	"./icons/mise/user_small": 27318,
	"./icons/mise/user_small.svg": 27318,
	"./icons/mise/users": 56911,
	"./icons/mise/users.svg": 56911,
	"./icons/mise/vkontakte": 76369,
	"./icons/mise/vkontakte.svg": 76369,
	"./icons/mise/wechat": 18343,
	"./icons/mise/wechat.svg": 18343,
	"./icons/mise/whatsapp": 99937,
	"./icons/mise/whatsapp.svg": 99937,
	"./icons/mise/youtube": 28706,
	"./icons/mise/youtube.svg": 28706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37939;